import styled, { css } from 'styled-components';
import Icon from '../../../_shared/components/Icon';
import Badge from '../../../_shared/components/Badge';
import { Year, Make, Model } from '../../Vdp/Overview/VehicleInfo/Styles';
import isOmpPlatform from '../../../_shared/utils/isOmpPlatform';

const isOmp = isOmpPlatform();

/**
 * Styled Components
 */
export const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 24px 18px 0;
`;

export const StyledAsIs = styled(Badge)`
  background-color: ${({ theme }) => theme.COLORS.ORANGE};
  border-radius: 18px;
  margin-right: 10px;
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  text-align: center;
  white-space: nowrap;
`;

export const StyledCloseButton = styled.button`
  border: 0;
  background: none;
  margin: 0 12px 0 0;
  padding: 0;
  outline: none;

  &:hover {
    cursor: pointer;
  }
`;

export const CloseIcon = styled(Icon).attrs({
  icon: 'TR5-Close_X'
})`
  width: 18px;
  height: 18px;
`;

const StyledHeadline = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: calc(100% - 30px);
`;

StyledHeadline.Year = styled(Year)`
  height: 25px;
  ${!isOmp &&
    css`
      padding: 3px 5px;
    `}
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  line-height: ${isOmp ? '23px' : 'normal'};
`;

StyledHeadline.Make = styled(Make)`
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  text-overflow: initial;
  overflow: visible;
`;

StyledHeadline.Model = styled(Model)`
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  max-width: 300px;
`;

export { StyledHeadline };

export default {};
